import { SceneShutterState } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionShutter',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionShutter extends SceneActionGeneral {
  SceneShutterState = SceneShutterState;

  get isConfirmEnabled() {
    return true;
  }
}
